import * as actionType from "./constants";

const initialState = {
    getProjectSettingsTemplateDataResponse: null,
    updateProjectSettingsTemplateResponse: null,
    addProjectSettingsTemplateResponse: null,
    deleteProjectSettingsTemplateResponse: null,
    getProjectSettingsTemplateByIdResponse: null,
    entityParams: {
        entity: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    }
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_PROJECT_SETTINGS_TEMPLATE_REQUEST:
            return {
                ...state,
                getProjectSettingsTemplateDataResponse: { isLoading: true }
            };
        case actionType.GET_PROJECT_SETTINGS_TEMPLATE_SUCCESS:
            return {
                ...state,
                getProjectSettingsTemplateDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_PROJECT_SETTINGS_TEMPLATE_FAILURE:
            return {
                ...state,
                getProjectSettingsTemplateDataResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.UPDATE_PROJECT_SETTINGS_TEMPLATE_REQUEST:
            return {
                ...state,
                updateProjectSettingsTemplateResponse: { isLoading: true }
            };
        case actionType.UPDATE_PROJECT_SETTINGS_TEMPLATE_SUCCESS:
            return {
                ...state,
                updateProjectSettingsTemplateResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_PROJECT_SETTINGS_TEMPLATE_FAILURE:
            return {
                ...state,
                updateProjectSettingsTemplateResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.ADD_PROJECT_SETTINGS_TEMPLATE_REQUEST:
            return {
                ...state,
                addProjectSettingsTemplateResponse: { isLoading: true }
            };
        case actionType.ADD_PROJECT_SETTINGS_TEMPLATE_SUCCESS:
            return {
                ...state,
                addProjectSettingsTemplateResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.ADD_PROJECT_SETTINGS_TEMPLATE_FAILURE:
            return {
                ...state,
                addProjectSettingsTemplateResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.DELETE_PROJECT_SETTINGS_TEMPLATE_REQUEST:
            return {
                ...state,
                deleteProjectSettingsTemplateResponse: { isLoading: true }
            };
        case actionType.DELETE_PROJECT_SETTINGS_TEMPLATE_SUCCESS:
            return {
                ...state,
                deleteProjectSettingsTemplateResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_PROJECT_SETTINGS_TEMPLATE_FAILURE:
            return {
                ...state,
                deleteProjectSettingsTemplateResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_REQUEST:
            return {
                ...state,
                getProjectSettingsTemplateByIdResponse: { isLoading: true }
            };
        case actionType.GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_SUCCESS:
            return {
                ...state,
                getProjectSettingsTemplateByIdResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_FAILURE:
            return {
                ...state,
                getProjectSettingsTemplateByIdResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_SETTINGS_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_SETTINGS_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };

        default:
            return state;
    }
};
export default reducers;
